import { BlockComponent } from 'lib'
import { CardBoundary, CardStyle, NoStyle } from 'experiences/dashboard/DashboardRoot/cards/components/Layout/styles'
import { LoadingBoundary } from 'components/patterns/suspense/Suspense'
import { SerializedStyles } from '@emotion/react'

import { DashboardItem } from 'experiences/dashboard/DashboardRoot'
import styled from '@emotion/styled'
import { FallbackComponent } from 'experiences/dashboard/DashboardRoot/fallbacks/hooks'

export type CardStyles = 'card' | 'none'

interface Props {
	item: DashboardItem
}

const StyleOptions: Record<CardStyles, SerializedStyles> = {
	card: CardStyle,
	none: NoStyle
}

export const GridElement: BlockComponent<Props> = ({ item }) => {
	const { Content, wrapperStyle = 'card', columns = 1, key, loadingContent } = item
	return (
		<CardBoundary cardStyle={StyleOptions[wrapperStyle]} columns={columns}>
			<LoadingBoundary
				fallback={loadingContent || <LoadingCard />}
				errorState={() => <FallbackComponent cardStyle={wrapperStyle} itemKey={key} />}
			>
				<Content />
			</LoadingBoundary>
		</CardBoundary>
	)
}

const LoadingCard = styled.div`
	width: 100%;
`
